export default __webpack_public_path__ + "static/media/property_747.46dd7d82.png";